module.exports = __webpack_public_path__ + "img/video.c1edf574.svg";